import React from 'react'
import { useMediaQuery } from 'react-responsive'

import logo from "../assets/logo.svg"

function Navbar() {

    const isMobile = useMediaQuery({ query: '(max-width: 992px)' })
    const isSmallMobile = useMediaQuery({ query: '(max-width: 768px)' })

    return (
        <>
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <div class={`container-fluid ${ isSmallMobile ? "mx-0" : "mx-5"}`}>
                    <a class="navbar-brand" href="#">
                        <img src={logo} alt="logo" className='img-fluid' />
                    </a>
                    {
                        isMobile ?
                            <>
                                <button class="btn btn-primary offcanvas-btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop"><i class="fa-solid fa-bars"></i></button>
                                <div class="offcanvas offcanvas-top" tabindex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
                                    <div class="offcanvas-header">
                                        {/* <h5 class="offcanvas-title" id="offcanvasTopLabel">Offcanvas top</h5> */}
                                        <a class="navbar-brand mx-4" href="#">
                                            <img src={logo} alt="logo" className='img-fluid' />
                                        </a>
                                        <button type="button" class="btn-close mx-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    </div>
                                    <div class="offcanvas-body">
                                        <ul class="navbar-nav  mb-2 mb-lg-0">
                                            <li class="nav-item">
                                                <a class="nav-link active" aria-current="page" href="#">About</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link active" href="#">Marketplace</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span class="navbar-toggler-icon"></span>
                                </button>
                                <div class="collapse navbar-collapse justify-content-center px-5" id="navbarSupportedContent">
                                    <ul class="navbar-nav  mb-2 mb-lg-0">
                                        <li class="nav-item">
                                            <a class="nav-link active" aria-current="page" href="#">About</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link active" href="#">Marketplace</a>
                                        </li>
                                    </ul>
                                </div>
                            </>
                    }

                    <div className='button ml-auto'>
                        <button className='btn'>Connect</button>
                    </div>
                </div>
            </nav>
        </>
    )
}

export default Navbar
